import React from "react";
import type { Category } from "@/types/finance";
import { Pencil, Trash2 } from "lucide-react";

export interface CategoryItemProps {
  category: Category;
  allCategories: Category[];
  onEdit: (cat: Category) => void;
  onDelete: (id: string, name: string) => void;
  level: number;
}

const CategoryItem: React.FC<CategoryItemProps> = ({
  category,
  allCategories,
  onEdit,
  onDelete,
  level,
}) => {
  const children = allCategories.filter((c) => c.parentId === category.id);
  return (
    <div className="flex flex-col">
      <div
        className={`flex justify-between items-center p-3 hover:bg-zinc-50 rounded-2xl transition-colors group ${
          level === 0 ? "bg-zinc-50/30" : ""
        }`}
      >
        <div
          className="flex items-center gap-3"
          style={{ paddingLeft: `${level * 24}px` }}
        >
          <div
            className={`w-1.5 h-6 rounded-full ${
              category.type === "income" ? "bg-[#3f83f8]" : "bg-rose-500"
            }`}
          ></div>
          <span
            className={`font-bold tracking-tight block ${
              level === 0 ? "text-zinc-800" : "text-zinc-600 text-sm"
            }`}
          >
            {category.name}
          </span>
        </div>
        <div className="flex items-center gap-1 opacity-100 transition-opacity">
          <button
            onClick={() => onEdit(category)}
            className="p-2 hover:bg-blue-50 text-[#3f83f8] rounded-xl"
            aria-label="Editar categoria"
            title="Editar"
          >
            <Pencil className="w-4 h-4" />
          </button>
          <button
            onClick={() => onDelete(category.id, category.name)}
            className="p-2 hover:bg-rose-50 text-rose-500 rounded-xl"
            aria-label="Excluir categoria"
            title="Excluir"
          >
            <Trash2 className="w-4 h-4" />
          </button>
        </div>
      </div>
      {children.map((child) => (
        <CategoryItem
          key={child.id}
          category={child}
          allCategories={allCategories}
          onEdit={onEdit}
          onDelete={onDelete}
          level={level + 1}
        />
      ))}
    </div>
  );
};

export default CategoryItem;
